import { render, staticRenderFns } from "./MyReviewsAI.vue?vue&type=template&id=447f4526&scoped=true&"
import script from "./MyReviewsAI.vue?vue&type=script&lang=js&"
export * from "./MyReviewsAI.vue?vue&type=script&lang=js&"
import style0 from "./MyReviewsAI.vue?vue&type=style&index=0&id=447f4526&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "447f4526",
  null
  
)

export default component.exports